export default "__VITE_ASSET__DcHi60_y__"